<template>
<div class="my-body text-white flex flex-wrap pt-24 md:pt-0 items-center px-8 sm:px-20 lg:px-40 xl:px-48">
    <div class="w-full md:w-1/2">
        <div>
            <p class="text-2xl md:text-3xl xl:text-4xl font-semibold md:font-bold  m-4">
                <span>{{settings.call_to_action_text}}</span><br />
            </p>
            <p class="mx-4 my-8">
                {{landingDesc}}
            </p>
            <div class="mx-4">
                <lbutton :color="btnColor" @click="$router.push('/learner/login')" style="color: white!important;">{{settings.call_to_action_button_text}}</lbutton>
            </div>
        </div>
    </div>
    <div class="w-full md:w-1/2">
        <img :src="landingImage" />
    </div>
</div>
</template>

<script>
import SettingsMixin from "@/mixins/SettingsMixin"
export default {
    mixins: [SettingsMixin],
    components: {
        lbutton: () => import("@/components/general/button"),
    },
    computed: {
       landingImage() {
            return 'https://edclearn-images.nyc3.cdn.digitaloceanspaces.com/home-screen/welcome.png';
        }
    }
};
</script>

<style lang="scss" scoped>
.my-body {
    height: 100vh;
    background-color: color(lms-tenant)
        /*background: linear-gradient(237.65deg, #0984e3 1.55%, #76c0fa 95.8%);*/
}

@media screen and (min-height: 750px) {
    .my-body {
        height: 90vh;
    }
}

div {
    color: white !important;
}
</style>
